import Avatar, { ConfigProvider } from "react-avatar";
import moment from "moment";

export const renderTooltip = (image, username, publishedAt) => (
  <ConfigProvider colors={["red", "green", "blue"]}>
    <div className="card rounded-xl shadow-xs border-0">
      <div>
        <Avatar round={true} name={username} size="40" />

        <span className="fs-13 fw-bold mb-0" style={{ marginLeft: "15px" }}>
          {username}
        </span>
        <span className="fw-medium text-muted">
          {" "}
          {moment(publishedAt).fromNow()}
        </span>
      </div>
      <div
        className="overflow-hidden rounded-xl ratio ratio-1x1 "
        style={{ marginTop: "10px" }}
      >
        <img src={image} alt="avatar" />
      </div>
    </div>
  </ConfigProvider>
);
